import React from 'react';
import PropTypes, { any } from 'prop-types';

import { ToggleSwitch } from '../../../Form';

const AwardCombinedDivisionDrawMedalToggle = (props) => {
    const {
        field,
        formApi,
    } = props;

    return (
        <div className={`col-12`}>
            <ToggleSwitch
                id={'awardCombinedDivisionDrawMedal'}
                field={field}
                formGroupCssClass={`mb16`}
                label="Award additional medals for combined division draws"
                isEventEditForm

                onChange={(val) => {
                    if (!val) {
                        formApi.setValue('awardCombinedDivisionDrawMedal', false);
                        formApi.setError(false);
                    }
                    if (val) {
                        formApi.setValue('awardCombinedDivisionDrawMedal', true);
                        formApi.setError(false);
                    }
                }}
                reverse={false}
            />
            <div className="div div16" />

        </div>
    );
};
AwardCombinedDivisionDrawMedalToggle.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
};
export default AwardCombinedDivisionDrawMedalToggle;
